var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 48,
    viewBox: "0 0 63 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1487_132394)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.33333,
    y: 7.96615,
    width: 46,
    height: 31.3333,
    rx: 3.66667,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.666667
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.667 30.5061C30.0783 31.8771 28.0174 32.7048 25.7654 32.7048C20.7405 32.7048 16.667 28.5841 16.667 23.5009C16.667 18.4176 20.7405 14.2969 25.7654 14.2969C28.0174 14.2969 30.0783 15.1246 31.667 16.4956C33.2558 15.1246 35.3167 14.2969 37.5687 14.2969C42.5936 14.2969 46.6671 18.4176 46.6671 23.5009C46.6671 28.5841 42.5936 32.7048 37.5687 32.7048C35.3167 32.7048 33.2558 31.8771 31.667 30.5061Z",
    fill: "#ED0006"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.667 30.5061C33.6232 28.8179 34.8637 26.3059 34.8637 23.5009C34.8637 20.6958 33.6232 18.1838 31.667 16.4956C33.2558 15.1246 35.3167 14.2969 37.5687 14.2969C42.5936 14.2969 46.667 18.4176 46.667 23.5009C46.667 28.5841 42.5936 32.7048 37.5687 32.7048C35.3167 32.7048 33.2558 31.8771 31.667 30.5061Z",
    fill: "#F9A000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6669 30.5105C33.6231 28.8223 34.8636 26.3103 34.8636 23.5052C34.8636 20.7002 33.6231 18.1882 31.6669 16.5C29.7106 18.1882 28.4702 20.7002 28.4702 23.5052C28.4702 26.3103 29.7106 28.8223 31.6669 30.5105Z",
    fill: "#FF5E00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1487_132394",
    x: 0.440945,
    y: 0.0737572,
    width: 61.7846,
    height: 47.1181,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.77953
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1487_132394"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1487_132394",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.41a5d1884e6b09e543bcffc1b2f54f4e.svg";
export { ForwardRef as ReactComponent };